function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2418 15.5169C20.0375 15.3126 19.7695 15.2104 19.5017 15.2104C19.2339 15.2104 18.966 15.3126 18.7616 15.5169L18.1651 16.1135L7.53857 5.48699L8.03526 4.9903C8.48783 4.53785 8.43165 3.78729 7.91582 3.40745L3.5802 0.214384C3.16354 -0.0923917 2.58534 -0.048824 2.21946 0.317056L0.378579 2.15805C0.0126995 2.52393 -0.0308683 3.10225 0.275908 3.51879L3.46886 7.85441C3.8487 8.37013 4.59881 8.42687 5.05171 7.97385L5.54841 7.47704L16.1749 18.1035L15.5364 18.7421C15.1276 19.1509 15.1276 19.8135 15.5364 20.2223L25.3396 30.0255C26.639 31.3249 28.7456 31.3249 30.045 30.0255C31.3444 28.7261 31.3444 26.6194 30.045 25.32L20.2418 15.5169Z",
  fill: "#282828"
});

var SvgModsvg = function SvgModsvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModsvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modsvg.46258d2e.svg";
export { ForwardRef as ReactComponent };